module.exports = __webpack_public_path__ + "static/portfolio-2-307aaf9e745f9ae47a99772405c7b79e.jpg";